<div id="closeBtn">
  <span  (click)="close()">×</span>
</div>

<div id="head_wrap">
  <section id="content">
    <h1 class="fontSize24">{{course.name}}</h1>
    <p class="fontSize14 lineHeight24">{{course.description}}</p>
    <div id="number" class="fontSize12">完成&nbsp;&nbsp;<span class="fontSize24">{{finishedNumber}}</span>/{{courseNumber}}</div>
  </section>
</div>

<div id="head_wrap_picture">

</div>

<div id="cards_wrap" >
    <div class="swiper-wrapper" >
        <div class="card swiper-slide" *ngFor="let lesson of course.lessons; let i=index" (click)="getLesson(i)" style="height:97%">
            <div class="cardPic">
                <div class="fontSize16 lessonStatus" *ngIf="finishedNumber!=i">
                    未解锁
                </div>
            </div>
            <div class="cardContent">
                <section>
                    <h1 class="fontSize16">{{i+1}}. {{lesson.name}}</h1>
                    <p class="fontSize14 lineHeight24">{{lesson.description}}</p>
                </section>
            </div>
        </div>
    </div>
</div>


<div id="shade"></div>

<div id="tip1" class="tip">
  <p class="fontSize16 lineHeight21">课程还未完成，确认要退出吗？</p>

  <button id="quitBtn" class="btnWord" (click)="exit();">退出</button>
  <button id="continueBtn" class="btnWord" (click)="continue();">继续</button>
</div>



// WEBPACK FOOTER //
// ./src/app/course-learning-home-page/course-learning-home-page.component.html